/**
 * En este fichero pueden estar funciones destinadas a cargar recursos como scripts y hojas de estilos, también se añade la función que carga la librería de D1C
 */

export function loadScript(path) {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.src = path
  document.head.appendChild(script)
}
